import styled from 'styled-components';

export const TableCard = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  background: #fff;
  border-radius: 13px;
  overflow: hidden;
`;

export const TableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: auto;
  box-sizing: border-box;

  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  ::-webkit-scrollbar-track {
    background: #f5f5f5;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #d8d8d8;
    border-radius: 10px;
  }
`;

export const OrdenoTable = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

export const OrdenoHeaderRow = styled.tr``;

export const OrdenoTh = styled.th<{ $center?: boolean }>`
  padding: 9px 14px;
  text-align: ${({ $center }) => ($center ? 'center' : 'left')};
  font-size: 10.5px;
  color: #696969;
  font-weight: 700;
  border-bottom: 1.5px solid #e9ecef;
  white-space: nowrap;
  background: #fafafa;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  position: sticky;
  top: 0;
  z-index: 1;

  &:first-child {
    padding-left: 20px;
  }
`;

export const OrdenoTr = styled.tr`
  border-bottom: 1px solid #f5f5f5;
  transition: background 0.1s;

  &:hover {
    background: #f8fbfd;
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const OrdenoGroupTr = styled(OrdenoTr)<{ $expandable?: boolean; $expanded?: boolean }>`
  cursor: ${({ $expandable }) => ($expandable ? 'pointer' : 'default')};
  background: ${({ $expanded }) => ($expanded ? '#f0f6ff' : 'transparent')};
  border-bottom: ${({ $expanded }) =>
    $expanded ? '1.5px solid #a8d8ee' : '1px solid #f5f5f5'};

  &:hover {
    background: ${({ $expanded }) => ($expanded ? '#e8f1fc' : '#f8fbfd')};
  }
`;

export const OrdenoItemTr = styled(OrdenoTr)`
  background: #fff;

  &:hover {
    background: #f8fbfd;
  }

  td:first-child {
    padding-left: 36px;
  }
`;

export const GroupCellInner = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ExpandArrow = styled.span<{ $expanded?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  flex-shrink: 0;
  color: #0090d3;
  font-size: 11px;
  line-height: 1;
  user-select: none;
`;

export const OrdenoTd = styled.td<{ $center?: boolean }>`
  padding: 9px 14px;
  font-size: 13px;
  vertical-align: middle;
  white-space: nowrap;
  text-align: ${({ $center }) => ($center ? 'center' : 'left')};
  color: #000;

  &:first-child {
    padding-left: 20px;
  }
`;

export const OrdenoTdActions = styled(OrdenoTd)`
  width: 48px;
  text-align: center;
  padding-right: 20px;
`;

export const TableFooter = styled.div`
  padding: 9px 20px;
  border-top: 1px solid #e9ecef;
  font-size: 11.5px;
  color: #999;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
`;

export const FooterLoadMore = styled.div`
  display: flex;
  justify-content: center;
  padding: 12px 20px 16px;
  border-top: 1px solid #e9ecef;
`;

export const CenteredCell = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const MessageContainer = styled.div`
  text-align: center;
  padding: 56px 24px;
  color: #999;
  font-size: 13px;
`;

export const ErrorMessage = styled(MessageContainer)`
  color: #f87171;
`;

export const StatusBadgeWrapper = styled.span<{ $bg: string; $color: string }>`
  display: inline-flex;
  align-items: center;
  padding: 3px 9px;
  border-radius: 32px;
  font-size: 11px;
  font-weight: 600;
  background-color: ${({ $bg }) => $bg};
  color: ${({ $color }) => $color};
  white-space: nowrap;
`;

export const ToolbarContainer = styled.div`
  display: none;
`;

export const ToolbarGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ToolbarLabel = styled.span`
  font-size: 12px;
  color: #696969;
  font-weight: 500;
`;

export const DateInput = styled.input`
  height: 34px;
  padding: 0 14px;
  border: none;
  border-radius: 32px;
  font-size: 13px;
  color: #303030;
  background: #ebebeb;
  font-family: 'Inter', sans-serif;

  &:focus {
    outline: none;
    box-shadow: 0 0 0 1.5px #0090d3;
  }
`;

export const SelectButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 34px;
  padding: 0 14px;
  border: none;
  border-radius: 32px;
  background: #ebebeb;
  font-size: 13px;
  color: #303030;
  cursor: pointer;
  font-family: 'Inter', sans-serif;
`;

export const DropdownPanel = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  z-index: 100;
  min-width: 200px;
  background: #fff;
  border: 1.5px solid #e9ecef;
  border-radius: 12px;
  box-shadow: 0 10px 32px rgba(0, 0, 0, 0.14);
  padding: 6px 0;
`;

export const DropdownOption = styled.button<{ $active?: boolean }>`
  display: block;
  width: 100%;
  text-align: left;
  padding: 8px 14px;
  border: none;
  background: ${({ $active }) => ($active ? '#e6f4fb' : 'transparent')};
  color: ${({ $active }) => ($active ? '#0090d3' : '#303030')};
  font-size: 13px;
  cursor: pointer;
`;

export const FilterChipsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 0 0 12px;

  &:last-child {
    padding-bottom: 0;
  }
`;

export const FilterDropdownPanel = styled.div`
  padding: 4px 0;
  min-width: 320px;
  max-width: 480px;
`;

export const FilterChip = styled.button<{ $active?: boolean }>`
  display: inline-flex;
  align-items: center;
  padding: 4px 11px;
  border-radius: 20px;
  border: 1.5px solid ${({ $active }) => ($active ? '#0090d3' : '#d8d8d8')};
  background: ${({ $active }) => ($active ? '#e6f4fb' : 'transparent')};
  color: ${({ $active }) => ($active ? '#0090d3' : '#696969')};
  font-size: 11.5px;
  font-weight: ${({ $active }) => ($active ? 700 : 500)};
  cursor: pointer;
  transition: all 0.12s ease;
  font-family: 'Inter', sans-serif;

  &:hover {
    border-color: ${({ $active }) => ($active ? '#0090d3' : '#b8b8b8')};
    color: ${({ $active }) => ($active ? '#0090d3' : '#000')};
  }
`;

export const RelativeWrap = styled.div`
  position: relative;
`;
